// Widget Scripts
import customTicketButton from './js/widgets/customTicketButton.js';
import mainSlideshow from './js/widgets/mainSlideshow.js';
import seoBlock from './js/widgets/seoBlock.js';
import cardWidget from './js/widgets/cardWidget.js';
import autoEventFeed from './js/widgets/tier-4-section/autoEventFeed.js';
import * as socialNetworkWidget from './js/widgets/tier-4-section/socialNetworkWidget.js';
import scrollerSponsors from './js/widgets/scrollerSponsors.js';
import partnerLogos from './js/widgets/partnerLogos.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
$(document).ready(function () {
  customTicketButton();
  if (globalThis.location.pathname === '/') {
    mainSlideshow();
    seoBlock();
    cardWidget();
    autoEventFeed();
    $(globalThis).on('load', function () {
      socialNetworkWidget.facebookfeed(true);
    });
    scrollerSponsors();
  }
  partnerLogos();
});
